import React from 'react'
import style from './footer.module.css'
import global from '../pages/general.module.css'
import { FaInstagram, FaFacebookSquare } from 'react-icons/fa';


class Footer extends React.Component {

  render() {
    return (
      <div className={style.footer}>
        <div className={global.container}>
          <div className={style.row}>

            <div className={`${style.menu}`} style={{textAlign: "center", width: "100%"}}>
              <div>
                <a href="https://www.instagram.com/tastingvictoria/" target="_blank" rel="noopener noreferrer">
                <FaInstagram 
                  color={"#fff"} 
                  size={32} 
                  style={{marginRight: "10px"}}/>
                </a>
               
                <a href="https://www.facebook.com/tastingvictoria/" target="_blank" rel="noopener noreferrer">
                  <FaFacebookSquare color={"#fff"} size={32} />
                </a>
              </div>
              <h3 className={style.footerTitle} >Follow Us</h3>

            </div>

            <div style={{textAlign: "center", width: "100%", marginTop: "30px"}}>
              <a href="mailto:info@tastingvictoria.com" style={{color: "#fff", textDecoration: "none"}}>info@tastingvictoria.com</a>
              <h3 className={style.footerTitle} style={{marginTop: "5px"}} >Contact Us</h3>
            </div>

          </div>
          <div className={style.credits}>
            <p style={{ marginTop: "30px", textAlign: "center", width: "100%", marginBottom: "20px"}}>Copyright © 2020. Tasting Victoria</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
